import { stateStatusType, VideoGroupProps } from './actionType';

// FetchVideoGroupSState
export interface FetchVideoGroupsState {
    isLoading: boolean;
    error: string | null;
    groups: VideoGroupProps[];
    status: stateStatusType | null;
    delete: string | null;
}

export const initialVideoGroupsState: FetchVideoGroupsState = {
    isLoading: false,
    error: null,
    groups: [],
    status: null,
    delete: null,
};

export interface VideoGroupState {
    videoGroupsState: FetchVideoGroupsState;
}

export const initialState: VideoGroupState = {
    videoGroupsState: initialVideoGroupsState,
};


